import { Shimmer } from '@components';

import { Container } from '../EquipmentBar.styles';

const EquipmentBarLoading = () => {
  return (
    <Container>
      <Shimmer
        style={{ height: 40, width: '100%', borderRadius: 8 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
    </Container>
  );
};

export { EquipmentBarLoading };
